<template>
  <v-row dense align="center" class="mb-1">
    <!-- Select Categorie -->
    <v-col cols="12" sm="4">
      <DxSelectBox
        v-model="selectedCategory"
        :items="categories"
        display-expr="Denumire"
        value-expr="TipComanda"
        placeholder="Categorie"
      />
    </v-col>

    <!-- Data Start -->
    <v-col cols="12" sm="2">
      <DxDateBox
        v-model="dataStart"
        type="date"
        display-format="yyyy-MM-dd"
        show-clear-button="true"
        placeholder="Start"
      />
    </v-col>

    <!-- Data End -->
    <v-col cols="12" sm="2">
      <DxDateBox
        v-model="dataEnd"
        type="date"
        display-format="yyyy-MM-dd"
        show-clear-button="true"
        placeholder="End"
        :min="dataStart"
      />
    </v-col>

    <!-- Buton Cauta -->
    <v-col cols="12" sm="2">
      <v-btn color="red darken-1" class="mt-0" @click="applyFilters" small>
        Caută
      </v-btn>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import DataSource from "devextreme/data/data_source";
import ODataStore from "devextreme/data/odata/store";
import AppSetting from "@/settings/appSettings";
import DxDateBox from "devextreme-vue/date-box";
import DxSelectBox from "devextreme-vue/select-box";

interface Filter {
  category: number | null;
  start: string;
  end: string;
}

const emit = defineEmits<{
  (e: "filtersChanged", filters: Filter): void;
}>();

const selectedCategory = ref<number | null>(null);
const categories = ref<any[]>([]);

const dataStart = ref<Date | null>(new Date());
const dataEnd = ref<Date | null>(new Date());

// Încarcă categorii din OData
const dsCategorii = new DataSource({
  store: new ODataStore({
    url: AppSetting.API_Url_ComercialOdata + "PRO_CategoriiComenzi",
    key: "Id",
    version: 4,
    beforeSend: (e: any) => {
      e.headers = {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
      };
    },
  }),
});

// Funcție de formatare ISO yyyy-MM-dd
function formatDate(d: Date | null) {
  return d ? d.toISOString().split("T")[0] : "";
}

// Emitere filtre
function applyFilters() {
  emit("filtersChanged", {
    category: selectedCategory.value !== null ? Number(selectedCategory.value) : null,
    start: formatDate(dataStart.value),
    end: formatDate(dataEnd.value),
  });
}

// Încărcare categorii
onMounted(async () => {
  const data = await dsCategorii.load();
  categories.value = data;
  if (categories.value.length > 0) selectedCategory.value = categories.value[0].TipComanda;
});
</script>
